import React, {Component} from "react";
import Container from "../../../../modules/commons/Container";
import {NavLink} from "react-router-dom";
import FlexView from "react-flexview";

class DashboardTeamLeader extends Component {
    constructor(props) {
        super(props);
    }

    createSubMenu = (val, link, icon, id) => {
        return (
            <NavLink id={id} to={link}>
                <div
                    className="content"
                    style={{
                        backgroundColor: "#E74C3C",
                        width: 235,
                        height: 235,
                        margin: 'auto',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column' ,
                        borderWidth: 2,
                        borderColor: "#000000",
                        borderStyle: "solid",
                        borderRadius: 5,
                    }}
                >
                    <div
                        style={{
                            color: "#ffffff",
                        }}
                    >
                        <div className="icn" style={{margin: 10}}>
                            <i className={`${icon} fa-lg`}></i>
                        </div>
                        <div className="ttl">{val}</div>
                    </div>
                </div>
            </NavLink>
        );
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{gap: "20px"}}>
                        {this.createSubMenu(
                            "Laporan Harian By Team Leader",
                            "/dashboard/team-leader/team-leader",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_team_leader_team_leader"
                        )}
                        {this.createSubMenu(
                            "Laporan Harian By Salesman Dan CS",
                            "/dashboard/team-leader/salesman",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_team_leader_salesman"
                        )}
                        {this.createSubMenu(
                            "Laporan Jual Varian",
                            "/dashboard/team-leader/variant",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_team_leader_variant"
                        )}
                    </FlexView>
                </Container>
            </>
        );
    }
}

export default DashboardTeamLeader;